import React from 'react';

import { Icon } from '@chakra-ui/react';

export const BusinessCriticalIcon = props => (
  <Icon viewBox="0 0 96 96" color="inherit" h="full" w="full" {...props}>
    <g transform="translate(-684 -481)">
      <g>
        <g>
          <g>
            <g>
              <path
                d="M731.5 499.812 741.015 518.872 761.188 522.494 746.893 537.902 749.847 559.188 731.5 549.658 713.153 559.188 716.107 537.902 701.812 522.494 721.985 518.872 731.5 499.812Z"
                stroke="#F8B810"
                strokeWidth="3.95816"
                strokeLinecap="butt"
                strokeLinejoin="miter"
                strokeMiterlimit="4"
                stroke-opacity="1"
                fill="#F8B810"
                fillRule="nonzero"
                fillOpacity="1"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </Icon>
);
